import type { OneTimeOrderProduct } from '../components/subscription-detail/OneTimeOrderModal';

// Bundles available in the "Create one-time order" product picker.
// Price is per bundle; quantity on the order line is the number of bundles.
export const oneTimeOrderBundles: OneTimeOrderProduct[] = [{
  id: 'bundle-mixed-cellar-6',
  name: 'Mixed Cellar 6-Pack',
  price: 180,
  bundleContents: [{
    name: '2025 Fiano',
    quantity: 2
  }, {
    name: '2025 Rosé Grenache',
    quantity: 2
  }, {
    name: '2023 Tempranillo',
    quantity: 2
  }]
}];

export interface OneTimeOrderInventory {
  sku: string;
  subtitle: string;
  stock: number | null; // null = inventory not tracked
  color: string; // bottle placeholder tint
}

// Picker details keyed by product id (matches availableProducts and the bundles)
export const oneTimeOrderInventory: Record<string, OneTimeOrderInventory> = {
  p1: {
    sku: '25FID6',
    subtitle: '750ml · White Wine',
    stock: 142,
    color: '#FEF3C7'
  },
  p2: {
    sku: '24SHZ2',
    subtitle: '750ml · Red Wine',
    stock: 88,
    color: '#FECACA'
  },
  p3: {
    sku: '25CHD1',
    subtitle: '750ml · White Wine',
    stock: 7,
    color: '#FEF3C7'
  },
  p4: {
    sku: '23PNR3',
    subtitle: '750ml · Red Wine',
    stock: 0,
    color: '#FECACA'
  },
  p5: {
    sku: '24SAB4',
    subtitle: '750ml · White Wine',
    stock: 210,
    color: '#FEF3C7'
  },
  p6: {
    sku: '22CSR1',
    subtitle: '750ml · Red Wine',
    stock: 5,
    color: '#FECACA'
  },
  p7: {
    sku: '25RSG5',
    subtitle: '750ml · Rosé',
    stock: 96,
    color: '#FCE7F3'
  },
  p8: {
    sku: '23TEM4',
    subtitle: '750ml · Red Wine',
    stock: 64,
    color: '#FECACA'
  },
  p9: {
    sku: '24PGR2',
    subtitle: '750ml · White Wine',
    stock: null,
    color: '#FEF3C7'
  },
  p10: {
    sku: '25VIO1',
    subtitle: '750ml · White Wine',
    stock: 31,
    color: '#FEF3C7'
  },
  'bundle-mixed-cellar-6': {
    sku: 'MXC6PK',
    subtitle: '6 × 750ml · Mixed',
    stock: null,
    color: '#E0F2FE'
  }
};
